module.exports = __webpack_public_path__ + "img/logo_icon.55a3354d.svg";